import { ChevronRight } from "lucide-react";
import { Link } from "react-router";
import { PageHeader, SETTINGS_GROUPS, useTenant, visibleNav } from "@/components/AppShell";
import { t } from "@/lib/i18n";

/** Einstellungen: alle Punkte auf einer Seite, nach Thema gruppiert – je nach Rolle und gebuchten Modulen */
export function SettingsOverviewPage() {
  const { me, role, tenant } = useTenant();
  const items = visibleNav(me, role, tenant.permissions, tenant.modules, tenant.prospect).filter((n) => n.section === "settings");
  return (
    <div className="pb-16">
      <PageHeader title={t("Einstellungen")} description={t("Anbindungen, Regeln und euer Konto – alles an einem Ort.")} />
      <div className="px-4 md:px-8 grid gap-6 lg:grid-cols-2 max-w-5xl">
        {SETTINGS_GROUPS.map((g) => {
          const list = items.filter((n) => n.group === g.key);
          if (!list.length) return null;
          return (
            <section key={g.key}>
              <h2 className="px-1 pb-2 text-[11px] font-semibold uppercase tracking-wide text-fg-subtle">{t(g.title)}</h2>
              <div className="rounded-xl border border-border bg-surface divide-y divide-border overflow-hidden">
                {list.map((n) => (
                  <Link key={n.to} to={n.to} className="group flex items-center gap-3 px-4 py-3 hover:bg-surface-2/60 transition-colors">
                    <span className="size-8 shrink-0 grid place-items-center rounded-lg bg-surface-2 text-fg-muted group-hover:text-fg"><n.icon className="size-4" /></span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-[13.5px] font-medium">{t(n.label)}</span>
                      {n.desc && <span className="block text-[12px] text-fg-subtle truncate">{t(n.desc)}</span>}
                    </span>
                    <ChevronRight className="size-4 text-fg-subtle group-hover:text-fg-muted" />
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
